var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSourcingThemeLevelOne = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M7.698 2.526 2.526 7.698a.43.43 0 0 0 0 .605l5.172 5.172a.43.43 0 0 0 .605 0l5.172-5.172a.43.43 0 0 0 0-.605L8.303 2.526a.43.43 0 0 0-.605 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M8 5.847 5.847 8 8 10.154 10.154 8z"
})));
export default SvgSourcingThemeLevelOne;